export default "__VITE_ASSET__BvJtbpDP__"